// extracted by mini-css-extract-plugin
module.exports = {"mainHeader":"mainHeader_mainHeader__199zy"};